import { CookieName } from "@utilities/cookieKeys";

/**
 * Extracts a two-letter ISO country code from the CDN-provided
 * `x-client-region` request header. Returns `null` when the header
 * is missing or doesn't contain a valid code.
 */
export function getGeoCountryFromHeader(headers: Headers): string | null {
  const raw = headers.get("x-client-region")?.trim().toUpperCase();
  return raw && raw.length === 2 ? raw : null;
}

/**
 * Reads the two-letter ISO country code from the `geo_country` cookie
 * set by middleware. Returns `null` on the server or when the cookie is missing.
 */
export function getGeoCountryFromCookie(): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.split("; ").find(c => c.startsWith(`${CookieName.GeoCountry}=`));
  return match?.split("=")[1]?.toUpperCase() ?? null;
}
